// @flow
import React from 'react';
import type { ProductChildcareAvailabilitiesProps } from 'Components/widgets/product/Product.mapper';
import { ICONS } from 'Components/utils/icon/icons';
import { Availability } from './Availability';
import { AvailabilityAge } from './AvailabilityAge';

export const ProductChildcareAvailabilities = (props: ProductChildcareAvailabilitiesProps) => {
  const {
    availableLabel,
    childcareLabel,
    items,
    monthsLabel,
    remainingLabel,
    unavailableLabel,
    unknownLabel,
    yearLabel,
    yearsLabel,
  } = props;
  const renderConfig = {
    available: {
      label: availableLabel,
      icon: ICONS.SMALL_CHECK,
      color: 'emerald',
    },
    remaining: {
      label: remainingLabel,
      color: 'orange',
      icon: ICONS.WARNING,
    },
    unavailable: {
      label: unavailableLabel,
      color: 'red',
      icon: ICONS.SMALL_CROSS,
    },
    unknown: {
      label: unknownLabel,
      color: 'gray-medium',
    },
  };

  return (
    <div className="relative text-base font-bold py-2">
      {items.map(({ id, ageMin, ageMax, availability, remainingStock }) => (
        <div key={id} className="flex items-center justify-between text-gray-darker mb-3">
          <p className="my-0 font-bold">
            <AvailabilityAge
              ageMax={ageMax}
              ageMin={ageMin}
              childcareLabel={childcareLabel}
              monthsLabel={monthsLabel}
              yearLabel={yearLabel}
              yearsLabel={yearsLabel}
            />
          </p>
          <p className="flex my-0">
            <Availability
              availability={availability}
              remainingStock={remainingStock}
              config={renderConfig}
            />
          </p>
        </div>
      ))}
    </div>
  );
};
